import { useState } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/signInPreview.module.css";
import AuthGlassShell, { CardHead, MailIcon } from "./AuthGlassShell";

// Forgot password in the client preview: ask for the email, then confirm the link is on its way.
export default function ForgotPasswordPreview({ onSubmit }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const ready = /\S+@\S+\.\S+/.test(email.trim());

  const submit = async (e) => {
    e.preventDefault();
    if (!ready || busy) return;
    setBusy(true);
    try {
      if (await onSubmit(email.trim())) setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthGlassShell>
      <form className={styles.card} onSubmit={submit} noValidate>
        {sent ? (
          <>
            <CardHead title="Check your inbox" text={`If ${email.trim()} has a U-Send account, a link to set a new password is on its way.`} />
            <button type="button" className={styles.secondary} onClick={() => setSent(false)}>
              Use another email
            </button>
          </>
        ) : (
          <>
            <CardHead title="Forgot your password?" text="Enter your email and we send you a link to set a new one." />
            <label className={styles.field}>
              <span className={styles.srOnly}>Email</span>
              <MailIcon />
              <input
                type="email"
                name="email"
                inputMode="email"
                autoComplete="username"
                autoCapitalize="none"
                spellCheck="false"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>
            <button type="submit" className={styles.primary} disabled={!ready || busy}>
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </>
        )}
        <p className={styles.switch}>
          <Link to="/signin">Back to log in</Link>
        </p>
      </form>
    </AuthGlassShell>
  );
}
